import { useEffect, useState, Fragment, ReactFragment } from "react";
import home from "../../assets/images/home.png";
import newspaper from "../../assets/images/newspaper.png";
import plot from "../../assets/images/plot.png";
import website from "../../assets/images/website.png";
import sala from "../../assets/images/sala.png";
import consulta from "../../assets/images/consulta.png";
import { Box, makeStyles, Theme } from "@material-ui/core";
import Home from "../../utils/controlls/Home";
import Salas from "../../utils/controlls/Salas";
import Plataformas from "../../utils/controlls/Plataformas";
import Publicaciones from "../../utils/controlls/Publicaciones";
import MediosReportes from "../../utils/controlls/MediosReportes";
import Graficas from "../../utils/controlls/Graficas";
import NavBar from "../../utils/controlls/NavBar";
import MenuItem, { MenuItemProps } from "../../utils/controlls/MenuItem";
import "react-image-gallery/styles/css/image-gallery.css";
import "./inicio.css";

export default function Inicio2() {
  //#region Consts
  const [sizeWindow, setSizeWindow] = useState<any>({ alto: 0, ancho: 0 });
  // const classes = useStyles();
  const [currentComponent, setCurrentComponent] = useState<ReactFragment>(
    <Home />
  );
  //#endregion Consts

  const menuItems: MenuItemProps[] = [
    {
      id: 1,
      tooltip: "Información relevante",
      component: <Home />,
      icon: home,
    },
    {
      id: 2,
      tooltip: "Últimas publicaciones",
      component: <Publicaciones />,
      icon: newspaper,
    },
    { id: 3, tooltip: "Gráficas", component: <Graficas />, icon: plot },
    {
      id: 4,
      tooltip:
        "Conoce los medios de impugnación / Consulta los reportes estadísticos",
      component: <MediosReportes />,
      icon: consulta,
    },
    { id: 5, tooltip: "Salas", component: <Salas />, icon: sala },
    {
      id: 6,
      tooltip: "Plataformas jurisdiccionales",
      component: <Plataformas />,
      icon: website,
    },
  ];
  //#endregion styles

  //#region Effects
  useEffect(() => {
    localStorage.setItem("deshabilita", "0");
    ajustaSize();
    window.addEventListener("resize", ajustaSize);
    return () => {
      window.removeEventListener("resize", ajustaSize);
    };
  }, []);
  //#endregion Effects

  //#region LocalFunction
  const ajustaSize = () => {
    let screenAlto = window.innerHeight;
    let screenAncho = window.innerWidth;

    setSizeWindow({ alto: screenAlto, ancho: screenAncho });
  };

  function TabPanel(props: TabPanelProps) {
    const { children, value, index, ...other } = props;

    return (
      <div
        role="tabpanel"
        hidden={value !== index}
        id={`scrollable-auto-tabpanel-${index}`}
        aria-labelledby={`scrollable-auto-tab-${index}`}
        {...other}
      >
        {value === index && <Box p={3}>{children}</Box>}
      </div>
    );
  }

  function a11yProps(index: any) {
    return {
      id: `scrollable-auto-tab-${index}`,
      "aria-controls": `scrollable-auto-tabpanel-${index}`,
    };
  }

  const useStyles = makeStyles((theme: Theme) => ({
    root: {
      flexGrow: 1,
      width: "100%",
      backgroundColor: theme.palette.background.paper,
    },
  }));

  const handleComponent = (component: JSX.Element) => {
    setCurrentComponent(component);
  };
  //#endregion LocalFunction

  return (
    <>
      <div className="homeWrapper">
        {/* <div className="homeSideBar">
          {menuItems.map((mI) => {
            return (
              <div onClick={() => handleComponent(mI.component)}>
                <MenuItem
                  key={mI.id}
                  id={mI.id}
                  icon={mI.icon}
                  tooltip={mI.tooltip}
                  component={mI.component}
                />
              </div>
            );
          })}
        </div> */}
        <div className="contentWrapper">{currentComponent}</div>
        <NavBar
          parentState={currentComponent}
          setParentState={setCurrentComponent}
        />
      </div>
    </>
  );
}

interface TabPanelProps {
  children?: React.ReactNode;
  index: any;
  value: any;
}
